import { mapFileToName, isModel, iconType} from '@/utils/media.js'

export default {
  computed: {
    isModel() {
      return isModel(this.data.type);
    },
    iconType() {
      return iconType(this.data.type);
    },
    isDurationShow() {
      return (this.data.type == 'video' || this.data.type == 'youtube' || this.data.type == 'mp4link') && this.data.hasOwnProperty('duration');
    },
    isTagsExist() {
      return this.data.hasOwnProperty('tags') && Array.isArray(this.data.tags);
    },
    isThumbnailShow() {
      return (this.data.type == 'video' || this.data.type == 'youtube' || this.data.type == 'mp4link' || this.data.type == 'img' || this.data.type == 'pdf');
    },
    isThumbnailEditable() {
      return (this.data.type == 'video' || this.data.type == 'youtube' || this.data.type == 'mp4link');
    },
    isSubtitleEditable() {
      return (this.data.type == 'video' || this.data.type == 'youtube' || this.data.type == 'mp4link');
    },
    isOverlayEnabled() {
      return (this.data.type == 'video' || this.data.type == 'youtube' || this.data.type == 'mp4link');
    },
    isDownloadable() {
      var array = ["stl", "obj", "three", "collada", "ply", "gltf", "pdf", "img"];
      return array.includes(this.data.type) && this.data.content.includes('//');
    },
    isQuizProgressShow() {
        return this.data.question_total > 0;
    },
    thumbnailSource() {
      if(this.data.type == "youtube" && !this.data.thumbnail.includes('999.png')) {
        return this.stringThumbnailYoutube(this.data.thumbnail);
      } else if(this.data.type == "img") {
        return this.data.content;
      } else {
        return this.data.thumbnail;
      }
    },
  }, 
  methods: {
    mapFileToName(filename) {
      return mapFileToName(filename);
    },
    stringTimeFormatter(str) {
      var d = new Date(str);
      return d.toLocaleString();
    },
    stringThumbnailYoutube(thumbnail) {
      return "//img.youtube.com/vi/" + this.data.content + "/" + thumbnail + ".jpg"
    },
  }
};